module.exports = __webpack_public_path__ + "static/media/destination.885a7c67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mapIcons/destination.svg
// module id = 2559
// module chunks = 2